import collectUnknownKeys from './collectUnknownKeys.js';

/**
 * Finds the first key an object carries that its allowed list does not, and says so in the message
 * the caller gets back. Returns an empty string when every key is allowed.
 *
 * The rule itself lives in `collectUnknownKeys`, which the template sanitizer reads for the whole
 * list rather than the first offender.
 */

const describeUnknownKey = ({ value, allowed, where }) => {
  const [found] = collectUnknownKeys({ value, allowed });

  return found ? `${where} does not accept "${found}". Allowed: ${allowed.join(', ')}.` : '';
};

export default describeUnknownKey;
